import { FLAGLE_SHORT_URL } from '../../utils/share';
import { MatchModeConfig } from './matchConfig';

/**
 * A shared item is one short link:
 *   https://flagle.io/city-flags#img-420
 *   https://flagle.io/emblems#emb-gb
 *
 * The whole payload is the item's id in the fragment, which keeps the message
 * to a single line and lets the receiving page show the image before any data
 * has loaded — the id is enough to address the artwork on the CDN.
 */
export const buildItemShareUrl = (config: MatchModeConfig, itemId: string) =>
  `${FLAGLE_SHORT_URL}${config.path}#${config.sharePrefix}-${itemId}`;

export const readSharedItemId = (
  hash: string,
  config: MatchModeConfig,
): string | null =>
  new RegExp(`^#${config.sharePrefix}-([a-z0-9]+)$`).exec(hash)?.[1] ?? null;
